import V1Rank1CardArmor from "src/assets/images/knight/v1/rank1/card/armor.png";
import V1Rank1CardHelmet from "src/assets/images/knight/v1/rank1/card/helmet.png";
import V1Rank1CardShield from "src/assets/images/knight/v1/rank1/card/shield.png";
import V1Rank1CardSword from "src/assets/images/knight/v1/rank1/card/sword.png";
import V1Rank1ItemArmor from "src/assets/images/knight/v1/rank1/items/armor.png";
import V1Rank1ItemHand from "src/assets/images/knight/v1/rank1/items/hand.png";
import V1Rank1ItemHelmet from "src/assets/images/knight/v1/rank1/items/helmet.png";
import V1Rank1ItemShield from "src/assets/images/knight/v1/rank1/items/shield.png";
import V1Rank1ItemSword from "src/assets/images/knight/v1/rank1/items/sword.png";
import V1Rank1LightArmor from "src/assets/images/knight/v1/rank1/light/armor.png";
import V1Rank1LightHelmet from "src/assets/images/knight/v1/rank1/light/helmet.png";
import V1Rank1LightShield from "src/assets/images/knight/v1/rank1/light/shield.png";
import V1Rank1LightWeapon from "src/assets/images/knight/v1/rank1/light/weapon.png";
import V1Rank1Rank from "src/assets/images/knight/v1/rank1/rank.png";

import V1Rank2CardArmor from "src/assets/images/knight/v1/rank2/card/armor.png";
import V1Rank2CardHelmet from "src/assets/images/knight/v1/rank2/card/helmet.png";
import V1Rank2CardShield from "src/assets/images/knight/v1/rank2/card/shield.png";
import V1Rank2CardSword from "src/assets/images/knight/v1/rank2/card/sword.png";
import V1Rank2ItemArmor from "src/assets/images/knight/v1/rank2/items/armor.png";
import V1Rank2ItemHand from "src/assets/images/knight/v1/rank2/items/hand.png";
import V1Rank2ItemHelmet from "src/assets/images/knight/v1/rank2/items/helmet.png";
import V1Rank2ItemShield from "src/assets/images/knight/v1/rank2/items/shield.png";
import V1Rank2ItemSword from "src/assets/images/knight/v1/rank2/items/sword.png";
import V1Rank2LightArmor from "src/assets/images/knight/v1/rank2/light/armor.png";
import V1Rank2LightHelmet from "src/assets/images/knight/v1/rank2/light/helmet.png";
import V1Rank2LightShield from "src/assets/images/knight/v1/rank2/light/shield.png";
import V1Rank2LightWeapon from "src/assets/images/knight/v1/rank2/light/weapon.png";
import V1Rank2Rank from "src/assets/images/knight/v1/rank2/rank.png";

import V1Rank3CardArmor from "src/assets/images/knight/v1/rank3/card/armor.png";
import V1Rank3CardHelmet from "src/assets/images/knight/v1/rank3/card/helmet.png";
import V1Rank3CardShield from "src/assets/images/knight/v1/rank3/card/shield.png";
import V1Rank3CardSword from "src/assets/images/knight/v1/rank3/card/sword.png";
import V1Rank3ItemArmor from "src/assets/images/knight/v1/rank3/items/armor.png";
import V1Rank3ItemHand from "src/assets/images/knight/v1/rank3/items/hand.png";
import V1Rank3ItemHelmet from "src/assets/images/knight/v1/rank3/items/helmet.png";
import V1Rank3ItemShield from "src/assets/images/knight/v1/rank3/items/shield.png";
import V1Rank3ItemSword from "src/assets/images/knight/v1/rank3/items/sword.png";
import V1Rank3LightArmor from "src/assets/images/knight/v1/rank3/light/armor.png";
import V1Rank3LightHelmet from "src/assets/images/knight/v1/rank3/light/helmet.png";
import V1Rank3LightShield from "src/assets/images/knight/v1/rank3/light/shield.png";
import V1Rank3LightWeapon from "src/assets/images/knight/v1/rank3/light/weapon.png";
import V1Rank3Rank from "src/assets/images/knight/v1/rank3/rank.png";

import V1Rank4CardArmor from "src/assets/images/knight/v1/rank4/card/armor.png";
import V1Rank4CardHelmet from "src/assets/images/knight/v1/rank4/card/helmet.png";
import V1Rank4CardShield from "src/assets/images/knight/v1/rank4/card/shield.png";
import V1Rank4CardSword from "src/assets/images/knight/v1/rank4/card/sword.png";
import V1Rank4ItemArmor from "src/assets/images/knight/v1/rank4/items/armor.png";
import V1Rank4ItemHand from "src/assets/images/knight/v1/rank4/items/hand.png";
import V1Rank4ItemHelmet from "src/assets/images/knight/v1/rank4/items/helmet.png";
import V1Rank4ItemShield from "src/assets/images/knight/v1/rank4/items/shield.png";
import V1Rank4ItemSword from "src/assets/images/knight/v1/rank4/items/sword.png";
import V1Rank4LightArmor from "src/assets/images/knight/v1/rank4/light/armor.png";
import V1Rank4LightHelmet from "src/assets/images/knight/v1/rank4/light/helmet.png";
import V1Rank4LightShield from "src/assets/images/knight/v1/rank4/light/shield.png";
import V1Rank4LightWeapon from "src/assets/images/knight/v1/rank4/light/weapon.png";
import V1Rank4Rank from "src/assets/images/knight/v1/rank4/rank.png";

import V1Rank5CardArmor from "src/assets/images/knight/v1/rank5/card/armor.png";
import V1Rank5CardHelmet from "src/assets/images/knight/v1/rank5/card/helmet.png";
import V1Rank5CardShield from "src/assets/images/knight/v1/rank5/card/shield.png";
import V1Rank5CardSword from "src/assets/images/knight/v1/rank5/card/sword.png";
import V1Rank5ItemArmor from "src/assets/images/knight/v1/rank5/items/armor.png";
import V1Rank5ItemHand from "src/assets/images/knight/v1/rank5/items/hand.png";
import V1Rank5ItemHelmet from "src/assets/images/knight/v1/rank5/items/helmet.png";
import V1Rank5ItemShield from "src/assets/images/knight/v1/rank5/items/shield.png";
import V1Rank5ItemSword from "src/assets/images/knight/v1/rank5/items/sword.png";
import V1Rank5LightArmor from "src/assets/images/knight/v1/rank5/light/armor.png";
import V1Rank5LightHelmet from "src/assets/images/knight/v1/rank5/light/helmet.png";
import V1Rank5LightShield from "src/assets/images/knight/v1/rank5/light/shield.png";
import V1Rank5LightWeapon from "src/assets/images/knight/v1/rank5/light/weapon.png";
import V1Rank5Rank from "src/assets/images/knight/v1/rank5/rank.png";

import V2Rank1CardArmor from "src/assets/images/knight/v2/rank1/card/armor.png";
import V2Rank1CardHelmet from "src/assets/images/knight/v2/rank1/card/helmet.png";
import V2Rank1CardShield from "src/assets/images/knight/v2/rank1/card/shield.png";
import V2Rank1CardSword from "src/assets/images/knight/v2/rank1/card/sword.png";
import V2Rank1ItemArm from "src/assets/images/knight/v2/rank1/items/arm.png";
import V2Rank1ItemArmor from "src/assets/images/knight/v2/rank1/items/armor.png";
import V2Rank1ItemHand from "src/assets/images/knight/v2/rank1/items/hand.png";
import V2Rank1ItemHelmet from "src/assets/images/knight/v2/rank1/items/helmet.png";
import V2Rank1ItemShield from "src/assets/images/knight/v2/rank1/items/shield.png";
import V2Rank1ItemSword from "src/assets/images/knight/v2/rank1/items/sword.png";
import V2Rank1LightArmor from "src/assets/images/knight/v2/rank1/light/armor.png";
import V2Rank1LightHelmet from "src/assets/images/knight/v2/rank1/light/helmet.png";
import V2Rank1LightShield from "src/assets/images/knight/v2/rank1/light/shield.png";
import V2Rank1LightWeapon from "src/assets/images/knight/v2/rank1/light/weapon.png";
import V2Rank1Rank from "src/assets/images/knight/v2/rank1/rank.png";

import V2Rank2CardArmor from "src/assets/images/knight/v2/rank2/card/armor.png";
import V2Rank2CardHelmet from "src/assets/images/knight/v2/rank2/card/helmet.png";
import V2Rank2CardShield from "src/assets/images/knight/v2/rank2/card/shield.png";
import V2Rank2CardSword from "src/assets/images/knight/v2/rank2/card/sword.png";
import V2Rank2ItemArm from "src/assets/images/knight/v2/rank2/items/arm.png";
import V2Rank2ItemArmor from "src/assets/images/knight/v2/rank2/items/armor.png";
import V2Rank2ItemHand from "src/assets/images/knight/v2/rank2/items/hand.png";
import V2Rank2ItemHelmet from "src/assets/images/knight/v2/rank2/items/helmet.png";
import V2Rank2ItemShield from "src/assets/images/knight/v2/rank2/items/shield.png";
import V2Rank2ItemSword from "src/assets/images/knight/v2/rank2/items/sword.png";
import V2Rank2LightArmor from "src/assets/images/knight/v2/rank2/light/armor.png";
import V2Rank2LightHelmet from "src/assets/images/knight/v2/rank2/light/helmet.png";
import V2Rank2LightShield from "src/assets/images/knight/v2/rank2/light/shield.png";
import V2Rank2LightWeapon from "src/assets/images/knight/v2/rank2/light/weapon.png";
import V2Rank2Rank from "src/assets/images/knight/v2/rank2/rank.png";

import V2Rank3CardArmor from "src/assets/images/knight/v2/rank3/card/armor.png";
import V2Rank3CardHelmet from "src/assets/images/knight/v2/rank3/card/helmet.png";
import V2Rank3CardShield from "src/assets/images/knight/v2/rank3/card/shield.png";
import V2Rank3CardSword from "src/assets/images/knight/v2/rank3/card/sword.png";
import V2Rank3ItemArm from "src/assets/images/knight/v2/rank3/items/arm.png";
import V2Rank3ItemArmor from "src/assets/images/knight/v2/rank3/items/armor.png";
import V2Rank3ItemHand from "src/assets/images/knight/v2/rank3/items/hand.png";
import V2Rank3ItemHelmet from "src/assets/images/knight/v2/rank3/items/helmet.png";
import V2Rank3ItemShield from "src/assets/images/knight/v2/rank3/items/shield.png";
import V2Rank3ItemSword from "src/assets/images/knight/v2/rank3/items/sword.png";
import V2Rank3LightArmor from "src/assets/images/knight/v2/rank3/light/armor.png";
import V2Rank3LightHelmet from "src/assets/images/knight/v2/rank3/light/helmet.png";
import V2Rank3LightShield from "src/assets/images/knight/v2/rank3/light/shield.png";
import V2Rank3LightWeapon from "src/assets/images/knight/v2/rank3/light/weapon.png";
import V2Rank3Rank from "src/assets/images/knight/v2/rank3/rank.png";

import V2Rank4CardArmor from "src/assets/images/knight/v2/rank4/card/armor.png";
import V2Rank4CardHelmet from "src/assets/images/knight/v2/rank4/card/helmet.png";
import V2Rank4CardShield from "src/assets/images/knight/v2/rank4/card/shield.png";
import V2Rank4CardSword from "src/assets/images/knight/v2/rank4/card/sword.png";
import V2Rank4ItemArm from "src/assets/images/knight/v2/rank4/items/arm.png";
import V2Rank4ItemArmor from "src/assets/images/knight/v2/rank4/items/armor.png";
import V2Rank4ItemHand from "src/assets/images/knight/v2/rank4/items/hand.png";
import V2Rank4ItemHelmet from "src/assets/images/knight/v2/rank4/items/helmet.png";
import V2Rank4ItemShield from "src/assets/images/knight/v2/rank4/items/shield.png";
import V2Rank4ItemSword from "src/assets/images/knight/v2/rank4/items/sword.png";
import V2Rank4LightArmor from "src/assets/images/knight/v2/rank4/light/armor.png";
import V2Rank4LightHelmet from "src/assets/images/knight/v2/rank4/light/helmet.png";
import V2Rank4LightShield from "src/assets/images/knight/v2/rank4/light/shield.png";
import V2Rank4LightWeapon from "src/assets/images/knight/v2/rank4/light/weapon.png";
import V2Rank4Rank from "src/assets/images/knight/v2/rank4/rank.png";

import V2Rank5CardArmor from "src/assets/images/knight/v2/rank5/card/armor.png";
import V2Rank5CardHelmet from "src/assets/images/knight/v2/rank5/card/helmet.png";
import V2Rank5CardShield from "src/assets/images/knight/v2/rank5/card/shield.png";
import V2Rank5CardSword from "src/assets/images/knight/v2/rank5/card/sword.png";
import V2Rank5ItemArm from "src/assets/images/knight/v2/rank5/items/arm.png";
import V2Rank5ItemArmor from "src/assets/images/knight/v2/rank5/items/armor.png";
import V2Rank5ItemHand from "src/assets/images/knight/v2/rank5/items/hand.png";
import V2Rank5ItemHelmet from "src/assets/images/knight/v2/rank5/items/helmet.png";
import V2Rank5ItemShield from "src/assets/images/knight/v2/rank5/items/shield.png";
import V2Rank5ItemSword from "src/assets/images/knight/v2/rank5/items/sword.png";
import V2Rank5LightArmor from "src/assets/images/knight/v2/rank5/light/armor.png";
import V2Rank5LightHelmet from "src/assets/images/knight/v2/rank5/light/helmet.png";
import V2Rank5LightShield from "src/assets/images/knight/v2/rank5/light/shield.png";
import V2Rank5LightWeapon from "src/assets/images/knight/v2/rank5/light/weapon.png";
import V2Rank5Rank from "src/assets/images/knight/v2/rank5/rank.png";

import EmptyArmor from "src/assets/images/knight/empty-armor.png";
import EmptyHelmet from "src/assets/images/knight/empty-helmet.png";
import EmptyShield from "src/assets/images/knight/empty-shield.png";
import EmptyWeapon from "src/assets/images/knight/empty-sword.png";

import ArenaTrava1 from "src/assets/images/knight/arena/arena_trava_1.png";
import ArenaTrava2 from "src/assets/images/knight/arena/arena_trava_2.png";
import ArenaTrava3 from "src/assets/images/knight/arena/arena_trava_3.png";
import ArenaTrava4 from "src/assets/images/knight/arena/arena_trava_4.png";
import ArenaTrava5 from "src/assets/images/knight/arena/arena_trava_5.png";

import V1VaultRank1 from "src/assets/images/knight/knight-vault/rank1.png";
import V1VaultRank2 from "src/assets/images/knight/knight-vault/rank2.png";
import V1VaultRank3 from "src/assets/images/knight/knight-vault/rank3.png";
import V1VaultRank4 from "src/assets/images/knight/knight-vault/rank4.png";
import V1VaultRank5 from "src/assets/images/knight/knight-vault/rank5.png";

const rank1Metadata = {
  percent: 0.6,
  color: "#BB6227",
  description:
    "These knights-in-training are the new recruitments of the Order of the Holy Knight of Trava, the fresh blood of the Kingdom. Despite the obvious lack of combat experience, Knight Apprentices are all determined and resolved to protect the Kingdom and their families.",
};
const rank2Metadata = {
  percent: 0.25,
  color: "#CFD7EC",
  description:
    "Only those of exceptional skills and techniques could graduate from the renowned Militari Academia of Trava Kingdom, and those who graduate are promoted to Knight Sergeant. These knights serve as the main force of the Kingdom, the Spear, the Shield, the Armor of which the Kingdom uses to fight the fierce dragons.",
};
const rank3Metadata = {
  percent: 0.1,
  color: "#FFC22E",
  description:
    "Knight Officers are veteran knights: having fought in as many battles as their years walking on Earth. Not only are their skills honed to respectable level, their deep understanding of dragons and battle tactics is also of insurmountable importance to the survival of the Trava Kingdom.",
};
const rank4Metadata = {
  percent: 0.045,
  color: "#7337BC",
  description:
    "Knight Commanders are officers who have fought at least an Elder Wyrm and walked out alive; and only those who are bravest, most fearless, most skillful and with deepest insight of the nature of these beasts could manage such a feat. As such, Knight Commanders are held in high regard by the people and the nobles, and are granted several special privileges by the King himself.",
};
const rank5Metadata = {
  percent: 0.005,
  color: "#325DCF",
  description:
    "Knight Grand Cross, the pillars of the Order of the Holy Knight, is reserved for but a selected few, for one good reason: not only do they need to be chivalrous, but they must also prove themselves worthy to Vivianne, Goddess of the Pool. Only then, these knights are blessed with the Armor of the Crystal, forged by the crystallized essence of the Lending Pool, blessed with Vivianne’s magic, making them powerful enough to slay even an Elder Wyrm. The exact criteria of gauging one’s worthiness is yet unknown, but all Knight Grand Cross share one common trait: their hearts are as pure as the Lending Pool on a summer day.",
};

export const V1Rank1 = {
  id: "v1rank1",
  rank: V1Rank1Rank,
  card: { armor: V1Rank1CardArmor, helmet: V1Rank1CardHelmet, shield: V1Rank1CardShield, weapon: V1Rank1CardSword },
  item: {
    armor: V1Rank1ItemArmor,
    helmet: V1Rank1ItemHelmet,
    shield: V1Rank1ItemShield,
    weapon: V1Rank1ItemSword,
    hand: V1Rank1ItemHand,
  },
  light: {
    armor: V1Rank1LightArmor,
    helmet: V1Rank1LightHelmet,
    shield: V1Rank1LightShield,
    weapon: V1Rank1LightWeapon,
  },
  description: {
    armor:
      "A generic copper armor. Looks plain and boring, but most knights learn to appreciate it under the dragon's fiery breath.",
    helmet:
      "A generic copper helmet. Although it looks old and rusty, it is imbued with the power of the Lending Pool, and still better than nothing in the midst of the battlefield.",
    shield:
      "A generic copper shield. Smart knights would never venture out to the battlefield without a shield, however unreliable it may look.",
    weapon:
      "A generic copper sword. Even with its loose hilt and cracked edge, the blessing of the Lending Pool still enables it to tear through dragons' flesh.",
  },
  metadata: rank1Metadata,
};

export const V1Rank2 = {
  id: "v1rank2",
  rank: V1Rank2Rank,
  card: { armor: V1Rank2CardArmor, helmet: V1Rank2CardHelmet, shield: V1Rank2CardShield, weapon: V1Rank2CardSword },
  item: {
    armor: V1Rank2ItemArmor,
    helmet: V1Rank2ItemHelmet,
    shield: V1Rank2ItemShield,
    weapon: V1Rank2ItemSword,
    hand: V1Rank2ItemHand,
  },
  light: {
    armor: V1Rank2LightArmor,
    helmet: V1Rank2LightHelmet,
    shield: V1Rank2LightShield,
    weapon: V1Rank2LightWeapon,
  },
  description: {
    armor:
      "An armor forged from fine silver. Usually a reward for young knights graduated with excellency from University of Trava Knight.",
    helmet:
      "A helmet forged from fine silver. On its top lie the signature horns, which symbol certain victory and eternal triumph in the Kingdom of Trava.",
    shield:
      "A shield forged from fine silver. Lightweight and easy to handle, it is a very popular choice among young knights.",
    weapon:
      "A sword forged from fine silver. Its double-edged and jagged blade ensures a painful experience for the dragons… or the user, should he handle carelessly.",
  },
  metadata: rank2Metadata,
};

export const V1Rank3 = {
  id: "v1rank3",
  rank: V1Rank3Rank,
  card: { armor: V1Rank3CardArmor, helmet: V1Rank3CardHelmet, shield: V1Rank3CardShield, weapon: V1Rank3CardSword },
  item: {
    armor: V1Rank3ItemArmor,
    helmet: V1Rank3ItemHelmet,
    shield: V1Rank3ItemShield,
    weapon: V1Rank3ItemSword,
    hand: V1Rank3ItemHand,
  },
  light: {
    armor: V1Rank3LightArmor,
    helmet: V1Rank3LightHelmet,
    shield: V1Rank3LightShield,
    weapon: V1Rank3LightWeapon,
  },
  description: {
    armor:
      "An exceptional armor made of pure gold. Reinforced with spiked shoulders, this armor deters even the most ferocious foes from entering close-quarter combat with the wielder.",
    helmet:
      "An exceptional helmet made of pure gold. Its quality ensures high-grade protection against the intense heat of dragon’s breath.",
    shield:
      "An exceptional shield made of pure gold. Unlike typical shields, its unusual shape allows its wielders to launch devastating counter-attacks even in most dire situations.",
    weapon:
      "An exceptional axe made of pure gold. Wielded by the fiercest of warriors, the frontal bit is forged to slice through dragons’ skins, while the hindmost tip is forged to pierce into their dying hearts.",
  },
  metadata: rank3Metadata,
};

export const V1Rank4 = {
  id: "v1rank4",
  rank: V1Rank4Rank,
  card: { armor: V1Rank4CardArmor, helmet: V1Rank4CardHelmet, shield: V1Rank4CardShield, weapon: V1Rank4CardSword },
  item: {
    armor: V1Rank4ItemArmor,
    helmet: V1Rank4ItemHelmet,
    shield: V1Rank4ItemShield,
    weapon: V1Rank4ItemSword,
    hand: V1Rank4ItemHand,
  },
  light: {
    armor: V1Rank4LightArmor,
    helmet: V1Rank4LightHelmet,
    shield: V1Rank4LightShield,
    weapon: V1Rank4LightWeapon,
  },
  description: {
    armor:
      "A armor forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. It offers invulnerability against dragon’s tooth and claws, and is also capable of exploding, expending all of its magical energy as a last resort.",
    helmet:
      "A helmet forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. As diamond is the perfect catalyst to contain holy magic, this helmet not only protects the wearer from attacks, but also enhances his visions in the dark - a trait most wanted when the sky is full of dragons.",
    shield:
      "A shield forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool.  The shield is made of a diamond core and clad in a special alloy, allowing the wielder to absorb the dragon’s breath and release the absorbed energy in a highly concentrated beam.",
    weapon:
      "A mace forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. The mace is made of a diamond core and clad in a special alloy, allowing it to strike deep into dragon flesh and explode into an everlasting wound - should the dragon escape alive.",
  },
  metadata: rank4Metadata,
};

export const V1Rank5 = {
  id: "v1rank5",
  rank: V1Rank5Rank,
  card: { armor: V1Rank5CardArmor, helmet: V1Rank5CardHelmet, shield: V1Rank5CardShield, weapon: V1Rank5CardSword },
  item: {
    armor: V1Rank5ItemArmor,
    helmet: V1Rank5ItemHelmet,
    shield: V1Rank5ItemShield,
    weapon: V1Rank5ItemSword,
    hand: V1Rank5ItemHand,
  },
  light: {
    armor: V1Rank5LightArmor,
    helmet: V1Rank5LightHelmet,
    shield: V1Rank5LightShield,
    weapon: V1Rank5LightWeapon,
  },
  description: {
    armor:
      "This armor is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. An armor truly fits champions of the realm, it is nigh impenetrable - both from physical assaults and magical blasts. Ancient magicks imbued into the armor vastly enhance the wielder’s strength, enabling him to overpower even the likes of Elder Wyrms.",
    helmet:
      "This helmet is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Not only does the helmet offer impeccable protection against any dragon’s magic, its wings also represent the collective hope of the entire Trava Kingdom’s history and heritage.",
    shield:
      "This shield is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. The insignia of the Trava Kingdom, carved onto the surface by the finest blacksmiths, and enchanted by the most powerful sages, grants total fire and ice immunity, and acts as a beacon of light should knights lose their way in darkest nights.",
    weapon:
      "This sword is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Enchanted by mystic magicks, the sword is capable of cutting through the hide of Elder Wyrms, fully negating their regenerative power. At night, the sword radiates a calming blue, warding off any stray beast that dares to cross the legendary knight’s path.",
  },
  metadata: rank5Metadata,
};

export const V2Rank1 = {
  id: "v2rank1",
  rank: V2Rank1Rank,
  card: { armor: V2Rank1CardArmor, helmet: V2Rank1CardHelmet, shield: V2Rank1CardShield, weapon: V2Rank1CardSword },
  item: {
    armor: V2Rank1ItemArmor,
    helmet: V2Rank1ItemHelmet,
    shield: V2Rank1ItemShield,
    weapon: V2Rank1ItemSword,
    arm: V2Rank1ItemArm,
    hand: V2Rank1ItemHand,
  },
  light: {
    armor: V2Rank1LightArmor,
    helmet: V2Rank1LightHelmet,
    shield: V2Rank1LightShield,
    weapon: V2Rank1LightWeapon,
  },
  description: {
    armor:
      "A generic copper armor. Looks plain and boring, but most knights learn to appreciate it under the dragon's fiery breath.",
    helmet:
      "A generic copper helmet. Although it looks old and rusty, it is imbued with the power of the Lending Pool, and still better than nothing in the midst of the battlefield.",
    shield:
      "A generic copper shield. Smart knights would never venture out to the battlefield without a shield, however unreliable it may look.",
    weapon:
      "A generic copper sword. Even with its loose hilt and cracked edge, the blessing of the Lending Pool still enables it to tear through dragons' flesh.",
  },
  metadata: rank1Metadata,
};

export const V2Rank2 = {
  id: "v2rank2",
  rank: V2Rank2Rank,
  card: { armor: V2Rank2CardArmor, helmet: V2Rank2CardHelmet, shield: V2Rank2CardShield, weapon: V2Rank2CardSword },
  item: {
    armor: V2Rank2ItemArmor,
    helmet: V2Rank2ItemHelmet,
    shield: V2Rank2ItemShield,
    weapon: V2Rank2ItemSword,
    arm: V2Rank2ItemArm,
    hand: V2Rank2ItemHand,
  },
  light: {
    armor: V2Rank2LightArmor,
    helmet: V2Rank2LightHelmet,
    shield: V2Rank2LightShield,
    weapon: V2Rank2LightWeapon,
  },
  description: {
    armor:
      "An armor forged from fine silver. Usually a reward for young knights graduated with excellency from University of Trava Knight.",
    helmet:
      "A helmet forged from fine silver. On its top lie the signature horns, which symbol certain victory and eternal triumph in the Kingdom of Trava.",
    shield:
      "A shield forged from fine silver. Lightweight and easy to handle, it is a very popular choice among young knights.",
    weapon:
      "A sword forged from fine silver. Its double-edged and jagged blade ensures a painful experience for the dragons… or the user, should he handle carelessly.",
  },
  metadata: rank2Metadata,
};

export const V2Rank3 = {
  id: "v2rank3",
  rank: V2Rank3Rank,
  card: { armor: V2Rank3CardArmor, helmet: V2Rank3CardHelmet, shield: V2Rank3CardShield, weapon: V2Rank3CardSword },
  item: {
    armor: V2Rank3ItemArmor,
    helmet: V2Rank3ItemHelmet,
    shield: V2Rank3ItemShield,
    weapon: V2Rank3ItemSword,
    arm: V2Rank3ItemArm,
    hand: V2Rank3ItemHand,
  },
  light: {
    armor: V2Rank3LightArmor,
    helmet: V2Rank3LightHelmet,
    shield: V2Rank3LightShield,
    weapon: V2Rank3LightWeapon,
  },
  description: {
    armor:
      "An exceptional armor made of pure gold. Reinforced with spiked shoulders, this armor deters even the most ferocious foes from entering close-quarter combat with the wielder.",
    helmet:
      "An exceptional helmet made of pure gold. Its quality ensures high-grade protection against the intense heat of dragon’s breath.",
    shield:
      "An exceptional shield made of pure gold. Unlike typical shields, its unusual shape allows its wielders to launch devastating counter-attacks even in most dire situations.",
    weapon:
      "An exceptional axe made of pure gold. Wielded by the fiercest of warriors, the frontal bit is forged to slice through dragons’ skins, while the hindmost tip is forged to pierce into their dying hearts.",
  },
  metadata: rank3Metadata,
};

export const V2Rank4 = {
  id: "v2rank4",
  rank: V2Rank4Rank,
  card: { armor: V2Rank4CardArmor, helmet: V2Rank4CardHelmet, shield: V2Rank4CardShield, weapon: V2Rank4CardSword },
  item: {
    armor: V2Rank4ItemArmor,
    helmet: V2Rank4ItemHelmet,
    shield: V2Rank4ItemShield,
    weapon: V2Rank4ItemSword,
    arm: V2Rank4ItemArm,
    hand: V2Rank4ItemHand,
  },
  light: {
    armor: V2Rank4LightArmor,
    helmet: V2Rank4LightHelmet,
    shield: V2Rank4LightShield,
    weapon: V2Rank4LightWeapon,
  },
  description: {
    armor:
      "A armor forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. It offers invulnerability against dragon’s tooth and claws, and is also capable of exploding, expending all of its magical energy as a last resort.",
    helmet:
      "A helmet forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. As diamond is the perfect catalyst to contain holy magic, this helmet not only protects the wearer from attacks, but also enhances his visions in the dark - a trait most wanted when the sky is full of dragons.",
    shield:
      "A shield forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool.  The shield is made of a diamond core and clad in a special alloy, allowing the wielder to absorb the dragon’s breath and release the absorbed energy in a highly concentrated beam.",
    weapon:
      "A mace forged from the Diamond of the Orange Mountain, and blessed by the deepwater of the Lending Pool. The mace is made of a diamond core and clad in a special alloy, allowing it to strike deep into dragon flesh and explode into an everlasting wound - should the dragon escape alive.",
  },
  metadata: rank4Metadata,
};

export const V2Rank5 = {
  id: "v2rank5",
  rank: V2Rank5Rank,
  card: { armor: V2Rank5CardArmor, helmet: V2Rank5CardHelmet, shield: V2Rank5CardShield, weapon: V2Rank5CardSword },
  item: {
    armor: V2Rank5ItemArmor,
    helmet: V2Rank5ItemHelmet,
    shield: V2Rank5ItemShield,
    weapon: V2Rank5ItemSword,
    arm: V2Rank5ItemArm,
    hand: V2Rank5ItemHand,
  },
  light: {
    armor: V2Rank5LightArmor,
    helmet: V2Rank5LightHelmet,
    shield: V2Rank5LightShield,
    weapon: V2Rank5LightWeapon,
  },
  description: {
    armor:
      "This armor is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. An armor truly fits champions of the realm, it is nigh impenetrable - both from physical assaults and magical blasts. Ancient magicks imbued into the armor vastly enhance the wielder’s strength, enabling him to overpower even the likes of Elder Wyrms.",
    helmet:
      "This helmet is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Not only does the helmet offer impeccable protection against any dragon’s magic, its wings also represent the collective hope of the entire Trava Kingdom’s history and heritage.",
    shield:
      "This shield is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. The insignia of the Trava Kingdom, carved onto the surface by the finest blacksmiths, and enchanted by the most powerful sages, grants total fire and ice immunity, and acts as a beacon of light should knights lose their way in darkest nights.",
    weapon:
      "This sword is forged from the crystallized essence of the Lending Pool, and only wielded by the most legendary knights of Trava Kingdom. Enchanted by mystic magicks, the sword is capable of cutting through the hide of Elder Wyrms, fully negating their regenerative power. At night, the sword radiates a calming blue, warding off any stray beast that dares to cross the legendary knight’s path.",
  },
  metadata: rank5Metadata,
};

export const KnightMapping = { copper: 0, silver: 1, gold: 2, diamond: 3, crystal: 4 };
export const TypeMapping = ["helmet", "armor", "weapon", "shield"];
export const RarityMapping = ["copper", "silver", "gold", "diamond", "crystal", "limited"];
export const CollectionName = ["genesis", "triumph"];
export const CollectionFullName = [
  "Knight Apprentice",
  "Knight Sergeant",
  "Knight Officer",
  "Knight Commander",
  "Knight Grand Cross",
];
export const EmptyKnight = {
  helmet: EmptyHelmet,
  armor: EmptyArmor,
  weapon: EmptyWeapon,
  shield: EmptyShield,
};
export const PowerRatingKnight = [1.6, 4.4, 12, 28.88, 280];

export const KnightVault = [V1VaultRank1, V1VaultRank2, V1VaultRank3, V1VaultRank4, V1VaultRank5];
export const ArenaTrava = [ArenaTrava1, ArenaTrava2, ArenaTrava3, ArenaTrava4, ArenaTrava5];
export const RankV1 = [V1Rank1Rank, V1Rank2Rank, V1Rank3Rank, V1Rank4Rank, V1Rank5Rank];
export const RankV2 = [V2Rank1Rank, V2Rank2Rank, V2Rank3Rank, V2Rank4Rank, V2Rank5Rank];
export const KnightV1 = [V1Rank1, V1Rank2, V1Rank3, V1Rank4, V1Rank5];
export const KnightV2 = [V2Rank1, V2Rank2, V2Rank3, V2Rank4, V2Rank5];
export const KnightCollection = [KnightV1, KnightV2];
